import { render, staticRenderFns } from "./ResourceHeaderDienstplan.vue?vue&type=template&id=caf06898&scoped=true"
import script from "./ResourceHeaderDienstplan.vue?vue&type=script&lang=ts"
export * from "./ResourceHeaderDienstplan.vue?vue&type=script&lang=ts"
import style0 from "./ResourceHeaderDienstplan.vue?vue&type=style&index=0&id=caf06898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf06898",
  null
  
)

export default component.exports